import { Link } from "gatsby";
import { OutboundLink } from "gatsby-plugin-gtag";
import { EuiSpacer } from "@elastic/eui";
import DangerBox from "components/Outdoor_Cameras/IN-9820_QFHD/Camera_Reset/DangerBox";
import SuccessBox from "components/Outdoor_Cameras/IN-9820_QFHD/Camera_Reset/PrimaryBox";
import NavButtons from "components/Outdoor_Cameras/IN-9820_QFHD/NavButtons";
import BreadCrumbs from "components/Layout/BreadCrumbs";
import SEOHelmet from "components/Layout/SEOHelmet";
import * as React from 'react';
export default {
  Link,
  OutboundLink,
  EuiSpacer,
  DangerBox,
  SuccessBox,
  NavButtons,
  BreadCrumbs,
  SEOHelmet,
  React
};